module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAaCAYAAABGiCfwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEbSURBVHgB7ZXvjcIwDMVfTh2A26AbHBtcN7gRLhsAG5RNGAEmgA2ACegGsEF5JkFCJQWbFvjCT3pqmtp1/jgO8KEHnMaorusBH576pQYJkwU1d85V6AID5dSaKqWd+D6kPLWUNroQf+IVdgW1Qxf4g73Bdp2a/Zkv3OcAPTdtNcF6I0t1xuwbXrwX0HHyi0tZNbPTtQTzfIwQUvoRfqgtg5WXndkNh03TWEscbN7sf+memYPFQ7yXM0X9W3wfmdkYIRFyhBKmJoOdEqFGChMYMAeTdObyTdnM2d5YfN9/qBWskL5q+g+muLeSA2lbxgqJQ2mgoK72s/WmlssSoexIMlgqv5S5b87eq4PFgOLwB/3+yKAWDDTDh2dxBL0ieBpImfWuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/twoactive.png
// module id = GS+F
// module chunks = 1